import React, { useState, useEffect } from 'react';
import '../../assets/Css/signup.css';
import '../../assets/Css/login.css';
import { Logo, signIn, tick } from '../../constant/Index';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from '../../hooks/Form';
import { useDispatch, useSelector } from 'react-redux';
import { ToastMessage } from '../../utils/ShowToastMessage';
import { setSuccess, clearMessage } from '../../store/reducers/globalReducers';
import { useUserRegisterMutation } from '../../store/services/AuthServices';

const Signup = () => {
    const [errors, setErrors] = useState([]);
    const [sub, setSub] = useState(false);
    const [Bsub, setBSub] = useState(false);
    const [Berrors, setBErrors] = useState([]);
    const { state: bstate, onChange: bonChange } = useForm({
        first_name: '',
        last_name: '',
        company_name: '',
        email: '',
        contact_no: '',
        password: '',
        confirm_password: '',
    });
    const { state, onChange } = useForm({
        first_name: '',
        last_name: '',
        email: '',
        contact_no: '',
        password: '',
        confirm_password: '',
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { success } = useSelector((state) => state.globalReducer);

    const [userData, response] = useUserRegisterMutation();

    const onBSubmit = (e) => {
        e.preventDefault();
        const FormDatas = new FormData();
        FormDatas.append('first_name', bstate.first_name);
        FormDatas.append('last_name', bstate.last_name);
        FormDatas.append('company_name', bstate.company_name);
        FormDatas.append('email', bstate.email);
        FormDatas.append('contact_no', bstate.contact_no);
        FormDatas.append('password', bstate.password);
        FormDatas.append('confirm_password', bstate.confirm_password);
        userData(FormDatas);
        setBSub(true);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const FormDatas = new FormData();
        FormDatas.append('first_name', state.first_name);
        FormDatas.append('last_name', state.last_name);
        FormDatas.append('email', state.email);
        FormDatas.append('contact_no', state.contact_no);
        FormDatas.append('password', state.password);
        FormDatas.append('confirm_password', state.confirm_password);
        userData(FormDatas);
        setSub(true);
    };

    useEffect(() => {
        if (success !== '') {
            ToastMessage(success);
        }
        return () => {
            dispatch(clearMessage());
        };
    }, [success]);

    useEffect(() => {
        if (response.isError && sub) {
            setErrors(response?.error?.data?.errors);
        } else if (response.isError && Bsub) {
            setBErrors(response?.error?.data?.errors);
        }
    }, [response?.error?.data]);

    useEffect(() => {
        if (response.isSuccess && sub) {
            setErrors([]);
            dispatch(setSuccess(response?.data?.message));
            state.first_name = '';
            state.last_name = '';
            state.email = '';
            state.contact_no = '';
            state.password = '';
            state.confirm_password = '';
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        }
        if (response.isSuccess && Bsub) {
            setBErrors([]);
            dispatch(setSuccess(response?.data?.message));
            bstate.first_name = '';
            bstate.last_name = '';
            bstate.email = '';
            bstate.company_name = '';
            bstate.contact_no = '';
            bstate.password = '';
            bstate.confirm_password = '';
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        }
    }, [response.isSuccess]);

    return (
        <>
            {/* modal starts here */}
            <div
                className="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="thank-you-wrapper">
                                <div className="thank-you-img-wrapper">
                                    <figure>
                                        <img src={tick} alt="" />
                                    </figure>
                                </div>
                                <div className="thank-you-content-wrapper">
                                    <h3>Thank You!</h3>
                                    <h4>For Signing Up in Flit</h4>
                                    <h6>Please Check Your email to continue</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* modal ends here */}
            {/* <!-- Sign In Page Start Here --> */}
            <section className="signinSec singin p-0">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="logo-wrapper">
                                <figure>
                                    <img src={Logo} alt="" />
                                </figure>
                            </div>
                            <div className="signInBox">
                                <div className="title">
                                    <h1>Sign Up</h1>
                                </div>
                                <div className="taglines">
                                    <h3>Welcome to Flit</h3>
                                </div>
                                <ul
                                    className="nav nav-tabs"
                                    id="myTab"
                                    role="tablist">
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            id="home-tab"
                                            data-toggle="tab"
                                            href="#home"
                                            role="tab"
                                            aria-controls="home"
                                            aria-selected="true">
                                            Customer
                                        </a>
                                    </li>
                                    {/* <li className="nav-item">
										<a
											className="nav-link"
											id="profile-tab"
											data-toggle="tab"
											href="#profile"
											role="tab"
											aria-controls="profile"
											aria-selected="false"
										>
											Business
										</a>
									</li> */}
                                </ul>
                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="home"
                                        role="tabpanel"
                                        aria-labelledby="home-tab">
                                        <div className="taglines pt-2">
                                            <p>
                                                Already a Member ?
                                                <Link to="/login">Sign In</Link>
                                            </p>
                                        </div>
                                        <form onSubmit={onSubmit}>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="First Name"
                                                    className={`${
                                                        errors &&
                                                        errors?.first_name
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    name="first_name"
                                                    value={state.first_name}
                                                    onChange={onChange}
                                                />
                                            </div>
                                            {errors && errors?.first_name && (
                                                <span className="errorMessage">
                                                    <p>
                                                        {errors &&
                                                            errors?.first_name}
                                                    </p>
                                                </span>
                                            )}
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Last Name"
                                                    className={`${
                                                        errors &&
                                                        errors?.last_name
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    name="last_name"
                                                    value={state.last_name}
                                                    onChange={onChange}
                                                />
                                            </div>
                                            {errors && errors?.last_name && (
                                                <span className="errorMessage">
                                                    <p>
                                                        {errors &&
                                                            errors?.last_name}
                                                    </p>
                                                </span>
                                            )}
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={state.email}
                                                    onChange={onChange}
                                                    className={`${
                                                        errors && errors?.email
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    placeholder="Email Address"
                                                />
                                            </div>
                                            {errors && errors?.email && (
                                                <span className="errorMessage">
                                                    <p>
                                                        {errors &&
                                                            errors?.email}
                                                    </p>
                                                </span>
                                            )}
                                            <div className="form-group">
                                                <input
                                                    type="number"
                                                    placeholder="Contact Number"
                                                    className={`${
                                                        errors &&
                                                        errors?.contact_no
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    name="contact_no"
                                                    value={state.contact_no}
                                                    onChange={onChange}
                                                />
                                            </div>
                                            {errors && errors?.contact_no && (
                                                <span className="errorMessage">
                                                    <p>
                                                        {errors &&
                                                            errors?.contact_no}
                                                    </p>
                                                </span>
                                            )}
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    placeholder="Password"
                                                    className={`${
                                                        errors &&
                                                        errors?.password
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    name="password"
                                                    value={state.password}
                                                    onChange={onChange}
                                                />
                                            </div>
                                            {errors && errors?.password && (
                                                <span className="errorMessage">
                                                    <p>
                                                        {errors &&
                                                            errors?.password}
                                                    </p>
                                                </span>
                                            )}
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    placeholder="Confirm Password"
                                                    className={`${
                                                        errors &&
                                                        errors?.confirm_password
                                                            ? 'SetErrorshow form-control'
                                                            : 'form-control'
                                                    }`}
                                                    name="confirm_password"
                                                    value={
                                                        state.confirm_password
                                                    }
                                                    onChange={onChange}
                                                />
                                            </div>
                                            {errors &&
                                                errors?.confirm_password && (
                                                    <span className="errorMessage">
                                                        <p>
                                                            {errors &&
                                                                errors?.confirm_password}
                                                        </p>
                                                    </span>
                                                )}
                                            <div className="col-md-12 px-0 text-right mt-3">
                                                <button
                                                    className="btn btn-secondary btnn signup-btn rounded-pill full"
                                                    type="submit">
                                                    Sign Up
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    {/* <div
										className="tab-pane fade"
										id="profile"
										role="tabpanel"
										aria-labelledby="profile-tab"
									>
										<div className="taglines pt-2 ">
											<p className="mb-2">
												Already a Member ?<a href="/login">Sign In</a>
											</p>
										</div>
										<form onSubmit={onBSubmit}>
											<div className="form-group">
												<input
													type="text"
													placeholder="First Name"
													className={`${
														Berrors && Berrors?.first_name
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													name="first_name"
													value={bstate.first_name}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.first_name && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.first_name}</p>
												</span>
											)}

											<div className="form-group">
												<input
													type="text"
													placeholder="Last Name"
													className={`${
														Berrors && Berrors?.last_name
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													name="last_name"
													value={bstate.last_name}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.last_name && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.last_name}</p>
												</span>
											)}
											<div className="form-group">
												<input
													type="text"
													className={`${
														Berrors && Berrors?.company_name
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													placeholder="Company Name"
													name="company_name"
													value={bstate.company_name}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.company_name && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.company_name}</p>
												</span>
											)}
											<div className="form-group">
												<input
													type="email"
													className={`${
														Berrors && Berrors?.email
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													placeholder="Email Address"
													name="email"
													value={bstate.email}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.email && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.email}</p>
												</span>
											)}
											<div className="form-group">
												<input
													type="number"
													placeholder="Contact Number"
													className={`${
														Berrors && Berrors?.contact_no
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													name="contact_no"
													value={bstate.contact_no}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.contact_no && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.contact_no}</p>
												</span>
											)}
											<div className="form-group">
												<input
													type="password"
													className={`${
														Berrors && Berrors?.password
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													name="password"
													value={bstate.password}
													onChange={bonChange}
													placeholder="Password"
												/>
											</div>
											{Berrors && Berrors?.password && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.password}</p>
												</span>
											)}
											<div className="form-group">
												<input
													type="password"
													className={`${
														Berrors && Berrors?.confirm_password
															? "SetErrorshow form-control"
															: "form-control"
													}`}
													placeholder="Confirm Password"
													name="confirm_password"
													value={bstate.confirm_password}
													onChange={bonChange}
												/>
											</div>
											{Berrors && Berrors?.confirm_password && (
												<span className="errorMessage">
													<p>{Berrors && Berrors?.confirm_password}</p>
												</span>
											)}
											<div className="col-md-12 px-0 text-right mt-3">
												<button
													className="btn btn-secondary btnn signup-btn rounded-pill full"
													type="submit"
												>
													Sign Up
												</button>
											</div>
										</form>
									</div> */}
                                </div>
                                {/* <div className="privacyDv mt-3">
									<p>Copyrights © 2022 Flit. All rights reserved.</p>
								</div> */}
                            </div>
                        </div>

                        <div className="col-lg-5 ml-auto col-md-6 p-0">
                            <div className="img-Dv">
                                <div className="imgBox">
                                    <figure>
                                        <img src={signIn} alt="" />
                                    </figure>
                                </div>

                                <div className="LogoBox">
                                    <figure>
                                        <a href="index.php">
                                            <img
                                                src="img/signinlogo.png"
                                                alt=""
                                            />
                                        </a>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Sign In Page End Here --> */}
        </>
    );
};

export default Signup;
